



import {Component, Vue, Prop, Watch, PropSync} from 'vue-property-decorator';
import SvgRender from "@/components/Atoms/SvgRender/SvgRender.vue";
import {ValidationFormMixin} from "@/mixins";
import {mixins} from "vue-class-component";

@Component({
  components: {SvgRender}
})
export default class TextInput extends mixins(ValidationFormMixin) {
  @Prop({required: true, type: String, default: ''}) name!: string
  @Prop({required: false, type: String, default: 'text'}) type!: string
  @Prop({required: false, type: String, default: ''}) value!: string
  @Prop({required: false, type: [String, Object], default: ''}) rules !: never
  @Prop({required: false, type: String, default: ''}) placeholder !: string
  @Prop(String) leftIcon?: string
  @Prop(String) rightIcon?: string
  @Prop({type: Boolean, default: false}) isSearch?: boolean
  @Prop({type: Boolean, default: false}) disabled?: boolean
  @Prop({type: Boolean, default: false}) isPointer?: boolean
  @PropSync('value', {type: String}) syncedValue!: string

  public showPass = false

  private get inputClass(): string {
    let className = ''
    if (this.rightIcon) className += 'has-right-icon'
    if (this.isSearch) className += 'is-search'
    return className
  }

  private onclickInput(): void {
    this.$emit('onClickToInput')
  }

  private onClickToLeftIcon(): void {
    this.$emit('onClickToLeftIcon')
  }

  private onClickToRightIcon(): void {
    this.$emit('onClickToRightIcon')

    if (this.type === 'password') {
      this.showPass = !this.showPass
    }
  }

  private handleFocusout(): void {
    this.$emit('focusout')
  }

  private onEnter(): void {
    this.$emit('onEnter')
  }
}
